export const OPEN_MODAL = 'DOWNLOAD/OPEN_MODAL';
export const REQUEST_DOWNLOAD_FILE = 'DOWNLOAD/REQUEST_FILE';
export const UPDATE_MODAL = 'DOWNLOAD/UPDATE_MODAL';
export const INIT_STATE = 'DOWNLOAD/INIT_STATE';
